<template>
  <table
    class="color-table uk-margin-remove-top uk-table uk-table-divider uk-table-justify"
  >
    <thead>
      <th>{{$t('fields.name')}}</th>
      <th>{{$t('fields.code')}}</th>
    </thead>
    <tbody>
      <tr :key="color.code" v-for="color in colors">
        <td>{{color.name}}</td>
        <td>
          <color-preview :code="color.code" />
          {{color.code}}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import ColorPreview from './ColorPreview';

export default {
  name: 'color-table',
  components: {
    ColorPreview,
  },
  props: {
    colors: {
      type: Array,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// ColorTable.vue?5cb09ee6